import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-employement-history',
  templateUrl: './employement-history.component.html',
  styleUrls: ['./employement-history.component.css']
})
export class EmployementHistoryComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
